import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import OSUnifier from "@/components/site/OSUnifier";
import ModulesScroll from "@/components/site/ModulesScroll";
import Trust from "@/components/site/Trust";
import Stats from "@/components/site/Stats";
import LogoMarquee from "@/components/site/LogoMarquee";
import Testimonial from "@/components/site/Testimonial";
import ContactForm from "@/components/site/ContactForm";
import AuditModal from "@/components/site/AuditModal";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-ab-bg text-ab-text">
      <Navbar />
      <Hero />
      <LogoMarquee />
      <OSUnifier />
      <ModulesScroll />
      <Stats />
      <Trust />
      <Testimonial />
      <ContactForm />
      <Footer />
      <AuditModal />
    </main>
  );
}
